const Shimmer = () => {
    return (
        <div className="flex gap-3 flex-wrap pt-20 px-4">
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
            <div className="w-[300px] h-[270px] bg-gray-300 rounded-xl"></div>
        </div>
    );
};
export default Shimmer 